import Icon from '../../components/Icon.vue'

Icon.register({
  'regular/kiss-wink-heart': {
    width: 504,
    height: 512,
    paths: [
      {
        d: 'M304 308.5c0 13-13.4 27.3-35.1 36.4 21.8 8.7 35.2 23 35.2 36 0 19.2-28.7 41.5-71.5 44h-0.5c-3.7 0-7-2.6-7.8-6.2-0.9-3.8 1.1-7.7 4.7-9.2l17-7.2c12.9-5.5 20.7-13.5 20.7-21.5s-7.8-16-20.8-21.5l-16.9-7.2c-6-2.6-5.7-12.4 0-14.8l17-7.2c12.9-5.5 20.7-13.5 20.7-21.5s-7.8-16-20.8-21.5l-16.9-7.2c-3.6-1.5-5.6-5.4-4.7-9.2 0.8-3.8 4.4-6.6 8.2-6.2 42.7 2.5 71.5 24.8 71.5 44zM374.5 225c-14.8-13.2-46.2-13.2-61 0l-9.5 8.5c-2.5 2.3-7.9 4.7-13.7 1.6-4.4-2.4-6.9-7.4-6.1-12.4 3.9-25.2 34.2-42.1 59.8-42.1s55.8 16.9 59.8 42.1c0.8 5-1.7 10-6.1 12.4-4.4 2.4-9.9 1.7-13.7-1.6zM136 208.5c0-17.7 14.3-32 32-32s32 14.3 32 32-14.3 32-32 32-32-14.3-32-32zM501.1 402.5c9.2 23.9-4.4 49.4-28.5 55.7l-83 21.5c-5.4 1.4-10.9-1.8-12.4-7.1l-22.9-82.6c-6.6-24 8.8-48.6 34-52.6 22-3.5 43.1 11.6 49 33l2.3 8.4 8.4-2.2c21.6-5.6 45.1 5.1 53.1 25.9zM334 436.3c17.7 64 10.9 39.5 13.4 46.8-30.5 13.4-64 20.9-99.4 20.9-137 0-248-111-248-248s111-248 248-248 248 111 247.9 248c0 31.8-6.2 62.1-17.1 90-6-1.5-12.2-2.8-18.6-2.9-5.6-9.7-13.6-17.5-22.6-23.9 6.7-19.9 10.4-41.1 10.4-63.2 0-110.3-89.7-200-200-200s-200 89.7-200 200 89.7 200 200 200c30.8 0 59.9-7.2 86-19.7z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/regular/kiss-wink-heart.js
// module id = 1783
// module chunks = 0